import { Link } from "react-router-dom";
import { LogIn } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { startGoogleSignIn } from "@/components/auth/GoogleSignInButton";

const GoogleGlyph = () => (
  <svg width="15" height="15" viewBox="0 0 48 48" aria-hidden="true">
    <path fill="#FFC107" d="M43.6 20.5H42V20H24v8h11.3C33.7 32.6 29.3 36 24 36c-6.6 0-12-5.4-12-12s5.4-12 12-12c3.1 0 5.9 1.2 8 3.1l5.7-5.7C34 6.1 29.3 4 24 4 12.9 4 4 12.9 4 24s8.9 20 20 20 20-8.9 20-20c0-1.2-.1-2.4-.4-3.5z"/>
    <path fill="#FF3D00" d="M6.3 14.7l6.6 4.8C14.6 16 18.9 13 24 13c3.1 0 5.9 1.2 8 3.1l5.7-5.7C34 6.1 29.3 4 24 4 16.3 4 9.7 8.3 6.3 14.7z"/>
    <path fill="#4CAF50" d="M24 44c5.2 0 9.8-2 13.3-5.2l-6.2-5.2C29.1 34.7 26.7 36 24 36c-5.3 0-9.7-3.4-11.3-8.1l-6.5 5C9.5 39.6 16.2 44 24 44z"/>
    <path fill="#1976D2" d="M43.6 20.5H42V20H24v8h11.3c-.8 2.3-2.3 4.2-4.2 5.6l6.2 5.2C40.9 35 44 30 44 24c0-1.2-.1-2.4-.4-3.5z"/>
  </svg>
);

// Shown only to signed-out visitors near buy buttons: returning members unlock instantly.
export const MemberSignInHint = ({ className = "" }) => {
  const { user } = useAuth();
  if (user) return null;
  return (
    <div
      data-testid="member-signin-hint"
      className={`flex flex-wrap items-center gap-x-3 gap-y-2 font-mono text-[11px] tracking-[0.1em] text-[#78716C] ${className}`}
    >
      <span className="uppercase tracking-[0.2em] text-[#A8A29E]">Already bought? Unlock instantly —</span>
      <button
        type="button"
        onClick={startGoogleSignIn}
        data-testid="hint-google-signin"
        className="inline-flex items-center gap-2 text-[#1C1917] hover:text-[#B45309] transition-colors"
      >
        <GoogleGlyph /> Sign in with Google
      </button>
      <span className="text-[#A8A29E]">or</span>
      <Link to="/login" className="inline-flex items-center gap-1.5 text-[#1C1917] hover:text-[#B45309] transition-colors">
        <LogIn size={13} /> log in
      </Link>
    </div>
  );
};
